import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { transferInvoiceDialog } from "../../styles/mui/tableListTheme";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import { ThemeProvider } from "@emotion/react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

export default function EmployeeShoppingItemDialog(props) {
  const { open, onClose, data } = props;

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          {`項目詳細(${data?.id})`}
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <ThemeProvider theme={transferInvoiceDialog}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>No.</TableCell>
                  <TableCell align="left">產品</TableCell>
                  <TableCell align="left">數量</TableCell>
                  <TableCell align="right">價錢/件</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.details?.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell align="left">{item.product}</TableCell>
                    <TableCell align="left">{item.qty}</TableCell>
                    <TableCell align="right">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "HKD",
                      }).format(item.discount_price)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={3}></TableCell>
                  <TableCell sx={{ fontWeight: "600" }} align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "HKD",
                    }).format(data?.total_discount_amount)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <HorizontalLinearStepper {...data} />
        </ThemeProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>取消</Button>
      </DialogActions>
    </Dialog>
  );
}

function HorizontalLinearStepper(props) {
  const steps = [
    "會計已核對",
    `已取貨 \u00a0 ${
      props.time_signed
        ? moment(props.time_signed).format("YYYY-MM-DD Ahh:mm ")
        : ""
    }`,
  ];
  return (
    <Box sx={{ width: "100%", m: 2, mt: 3 }}>
      <Stepper orientation="vertical">
        {steps.map((label, index) => {
          const stepProps = {};

          if (index === 0 && props.verified) {
            stepProps.completed = true;
          } else if (index === 1 && props.signature?.length > 0) {
            stepProps.completed = true;
          }

          return (
            <Step active={false} key={label} {...stepProps}>
              <StepLabel
                StepIconComponent={({ completed }) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: completed ? "green" : "#9e9e9e",
                        color: "#ffffff",
                        fontSize: 14,
                        width: 25,
                        height: 25,
                        borderRadius: "50%",
                      }}
                    >
                      {completed ? (
                        <CheckIcon fontSize="small" />
                      ) : (
                        <CloseIcon fontSize="small" />
                      )}
                    </div>
                  );
                }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
